import { render, staticRenderFns } from "./EmbedVideo.vue?vue&type=template&id=409b6610"
import script from "./EmbedVideo.vue?vue&type=script&lang=js"
export * from "./EmbedVideo.vue?vue&type=script&lang=js"
import style0 from "./EmbedVideo.vue?vue&type=style&index=0&id=409b6610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports